import axios from 'axios'
import { salesUrl, customerUrl, getHeader } from '../config'

const state = {
  customerList: [],
  customerGroupList: [],
  customerOrderList: [],
  customerOutstandingList: [],
  customerRatingList: [],
  customerOutstandingTotal: 0,
  customerOutstandingTotalSales: 0,
  customerOutstandingTotalSalePaid: 0,
  customerOutstandingDueTotal: 0,
  customerPlafondAmount: 0,
  customerOutstandingSalesList: [],
  customerListLite: []
}

const mutations = {
  SET_CUSTOMER_GROUP_LIST (state, obj) {
    state.customerGroupList = obj
  },
  SET_CUSTOMER_LIST (state, obj) {
    state.customerList = obj
  },
  SET_CUSTOMER_ORDER_LIST (state, obj) {
    state.customerOrderList = obj
  },
  SET_CUSTOMER_OUTSTANDING_LIST (state, obj) {
    state.customerOutstandingList = obj
  },
  SET_CUSTOMER_RATING_LIST (state, obj) {
    state.customerRatingList = obj
  },
  SET_CUSTOMER_OUTSTANDING_TOTAL (state, obj) {
    state.customerOutstandingTotal = obj
  },
  SET_CUSTOMER_OUTSTANDING_DUE_TOTAL (state, obj) {
    state.customerOutstandingDueTotal = obj
  },
  SET_CUSTOMER_PLAFOND_AMOUNT (state, obj) {
    state.customerPlafondAmount = obj
  },
  SET_CUSTOMER_OUTSTANDING_SALES_LIST (state, obj) {
    state.customerOutstandingSalesList = obj
  },
  SET_CUSTOMER_LIST_LITE (state, obj) {
    state.customerListLite = obj
  },
  SET_CUSTOMER_OUTSTANDING_TOTAL_SALES (state, obj) {
    state.customerOutstandingTotalSales = obj
  },
  SET_CUSTOMER_OUTSTANDING_TOTAL_SALES_PAID (state, obj) {
    state.customerOutstandingTotalSalePaid = obj
  }
}

const actions = {
  getCustomerRating: ({ commit }) => {
    axios.get(customerUrl + '/rating', { headers: getHeader() })
      .then(response => {
        console.log('rating')
        console.log(response.data.data)
        commit('SET_CUSTOMER_RATING_LIST', response.data.data)
      })
  },
  getCustomerOutstading: ({ commit }, payload) => {
    var data = {
      customer_no: payload.customer_no,
      year: payload.year,
      company_no: payload.company_no,
      salesman: payload.salesman
    }
    axios.post(salesUrl + '/customer/outstanding', data, { headers: getHeader() })
      .then(response => {
        commit('SET_CUSTOMER_OUTSTANDING_LIST', response.data.data)
      })
  },
  getCustomerOrderList: ({ commit }, payload) => {
    axios.post(customerUrl + '/order', payload, { headers: getHeader() })
      .then(response => {
        commit('SET_CUSTOMER_ORDER_LIST', response.data.data)
      })
      .catch(error => {
        console.log(error)
        console.log(error.response)
        commit('SET_CUSTOMER_ORDER_LIST', [])
      })
  },
  getCustomerList: ({ commit }) => {
    axios.get(customerUrl + '?active=true', { headers: getHeader() })
      .then(response => {
        commit('SET_CUSTOMER_LIST', response.data.data)
      })
  },
  getCustomerListLite: ({ commit }) => {
    axios.post(customerUrl + '/list', [], { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_CUSTOMER_LIST_LITE', response.data.data)
      })
      .catch(error => {
        console.log(error)
        console.log(error.response)
        commit('SET_CUSTOMER_LIST_LITE', [])
      })
  },
  getCustomerGroupList: ({ commit }) => {
    axios.get(customerUrl + '/group', { headers: getHeader() })
      .then(response => {
        commit('SET_CUSTOMER_GROUP_LIST', response.data.data)
      })
  },
  getCustomerOutstadingTotal: ({ commit }, payload) => {
    axios.post(customerUrl + '/sales-outstanding-expire', payload, { headers: getHeader() })
      .then(response => {
        commit('SET_CUSTOMER_OUTSTANDING_TOTAL', response.data.total_outstanding)
        commit('SET_CUSTOMER_OUTSTANDING_TOTAL_SALES', response.data.total_sales)
        commit('SET_CUSTOMER_OUTSTANDING_DUE_TOTAL', response.data.total_outstanding_due)
        commit('SET_CUSTOMER_PLAFOND_AMOUNT', response.data.plafond_amount)
        commit('SET_CUSTOMER_OUTSTANDING_SALES_LIST', response.data.data)
      })
  }
}
export default {
  state, mutations, actions
}
